import { render, staticRenderFns } from "./SaveInfoRecommendNew.vue?vue&type=template&id=683efc43&scoped=true"
import script from "./SaveInfoRecommendNew.vue?vue&type=script&lang=js"
export * from "./SaveInfoRecommendNew.vue?vue&type=script&lang=js"
import style0 from "./SaveInfoRecommendNew.vue?vue&type=style&index=0&id=683efc43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683efc43",
  null
  
)

export default component.exports